// extracted by mini-css-extract-plugin
module.exports = {"root":"page_root__Xp3MW","unbreakable":"page_unbreakable__5xoqL","section":"page_section__RBCq1","small":"page_small__H6GaU"};